// extracted by mini-css-extract-plugin
export var footer = "r_bZ";
export var footerWrap = "r_b0";
export var footerCopyright = "r_b1";
export var footerLink = "r_b2";